import React from 'react';
import { useNavigate } from 'react-router-dom';

const BigWoodCard = ({ isMobile = false }) => {
  const navigate = useNavigate();

  const defaultImage = '/assets/images/material-extract-hover-new.jpg';
  const hoverImage = '/assets/images/material-extract-hover2.png';

  return (
    <>
      {/* Default image */}
      <img
        src={defaultImage}
        alt="Interior scene with chrome lounge chair on glass block floor and suede texture panel"
        className="w-full h-full object-cover transition-opacity duration-700 ease-in-out group-hover/card:opacity-0"
      />

      {/* Hover image (crossfade) */}
      <img
        src={hoverImage}
        alt="Extracted glass block floor texture close-up"
        className="absolute inset-0 w-full h-full object-cover transition-opacity duration-700 ease-in-out opacity-0 group-hover/card:opacity-100"
      />

      {/* Try Out button on hover - bottom right, same edge spacing as reimagine visuals */}
      <div className="absolute bottom-0 right-0 z-20 p-4 md:p-6 opacity-0 group-hover/card:opacity-100 transition-opacity duration-700 ease-in-out">
        <button
          onClick={(e) => { e.stopPropagation(); navigate('/furniture-editing?highlight=texture'); }}
          className="rounded-2xl font-medium text-white cursor-pointer hover:scale-[1.02] transition-transform"
          style={{
            fontSize: isMobile ? '9.2px' : '12.65px',
            padding: isMobile ? '6.9px 16.1px' : '9.2px 23px',
            background: 'linear-gradient(135deg, rgba(234, 100, 20, 0.95) 0%, rgba(210, 80, 10, 0.90) 100%)',
            backdropFilter: 'blur(10px)',
            WebkitBackdropFilter: 'blur(10px)',
            border: '1px solid rgba(254, 131, 56, 0.8)',
            boxShadow: '0 4px 16px 0 rgba(200, 80, 10, 0.4), inset 0 1px 1px 0 rgba(255, 255, 255, 0.2), inset 0 -1px 2px 0 rgba(0, 0, 0, 0.2)'
          }}
        >
          Try Out
        </button>
      </div>

      {/* Gradient overlay (visible by default, hidden on hover) */}
      <div
        className="absolute inset-0 pointer-events-none transition-opacity duration-700 ease-in-out group-hover/card:opacity-0"
        style={{
          background: 'linear-gradient(to bottom, transparent 40%, rgba(0, 0, 0, 0.85) 100%)'
        }}
      />

      {/* Text overlay (visible by default, hidden on hover) */}
      <div className="absolute inset-0 z-10 p-4 md:p-6 flex flex-col justify-end pointer-events-none transition-opacity duration-700 ease-in-out group-hover/card:opacity-0">
        <div className="flex items-end justify-between">
          <div>
            <h3 className="font-bold text-[rgba(255,252,239,1)] mb-1" style={{ fontSize: isMobile ? '10px' : '15px' }}>Extract pure material references</h3>
            <p className="text-white/80 leading-relaxed italic whitespace-nowrap" style={{ fontSize: isMobile ? '6px' : '9px' }}>Prompt: extract the glass floor texture</p>
          </div>
          <p className="text-white font-bold flex-shrink-0" style={{ fontSize: isMobile ? '8px' : '11px' }}>See original</p>
        </div>
      </div>
    </>
  );
};

export default BigWoodCard;
